<script lang="ts">
	let { icons }: { icons: string[] } = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
	{@html icons.join("")}
</svg>
